import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { sendErrReport } from '~/infra/utils';
import { useAppConfig } from '~/store/store-context';
import { NameThisDocumentModal } from '../../NameThisDocumentModal/NameThisDocumentModal';
import { useUploadLegalTerms } from './hooks/useUploadLegalTerms';
export class PDFError extends Error {
    constructor(message){
        super(message);
    }
}
const removeFileExtension = (fileName)=>{
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) return fileName;
    return fileName.substring(0, lastDotIndex);
};
export const useUploadLegalTermsWithCustomName = (param)=>{
    let { onSettled, errorToastTestId, clearFileInput } = param;
    const { termsAndConditionsPDFSizeLimitInMegabytes: pdfSizeLimit } = useAppConfig();
    const { showModal, showErrorToast } = useOverlayContext();
    const { t: legalTexts } = useLocaleKeys('components.legalTermsDropdown');
    const { uploadLegalTerms, isLoading } = useUploadLegalTerms({
        onSettled,
        errorToastTestId
    });
    const uploadLegalTermsWithCustomName = async (file)=>{
        try {
            if (!file) {
                throw new PDFError('An uknown error has occurred.');
            }
            if (file.type !== 'application/pdf') {
                throw new PDFError('File is not a valid PDF.');
            }
            if (file.size > pdfSizeLimit * 1024 * 1024) {
                throw new PDFError('Please choose a file under 50MB');
            }
            const uploadedLegalTerms = await showModal({
                biName: 'name_this_document_modal',
                closeOnEscapeKey: true,
                closeOnClickOutside: true,
                content: (param)=>{
                    let { dismissModal } = param;
                    return /*#__PURE__*/ _jsx(NameThisDocumentModal, {
                        currentFileName: removeFileExtension(file === null || file === void 0 ? void 0 : file.name),
                        onConfirm: async (newFileName)=>await uploadLegalTerms({
                                file,
                                newFileName
                            }),
                        dismissModal: dismissModal
                    });
                }
            });
            return uploadedLegalTerms;
        } catch (error) {
            const isPdfError = error instanceof PDFError;
            const message = isPdfError ? error.message : legalTexts.unknownError();
            if (!isPdfError) {
                sendErrReport(error);
            }
            showErrorToast(message, errorToastTestId);
        } finally{
            clearFileInput();
        }
    };
    return {
        uploadLegalTerms: uploadLegalTermsWithCustomName,
        isLoading
    };
};
